import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { AiOutlineClear } from 'react-icons/ai'

const ByDate = ( {
  state
} ) => {
  const [ searchParams, setSearchParams ] = useSearchParams()
  const [ list, setList ] = state

  const clear = ( update ) => {
    update( value => {
      return value.map( i => ( { ...i, selected: false } ) )
    } )
  }

  const toggleStatus = ( update, index ) => {
    update( value => {
      return value.map( ( i, j ) => {
        const selected = j === index
        return {
          ...i,
          selected
        }
      } )
    } )
  }

  return <div className="hs air-2x gap-2x">
    <div className="hs gap-2x">
      <div className="vs bar">
        <h1 className="one size-2x8">date</h1>

        <button
          title="clear"
          onClick={ () => clear( setList ) }
        >
          <AiOutlineClear />
        </button>
      </div>

      <div className="vs wrap in-air-2x gap-2x bg-secondary br check-buttons">
        { list.map( ( item, index ) => <button
          key={ index }
          className={ `${ item.selected ? 'selected' : '' }` }
          onClick={ () => toggleStatus( setList, index ) }
        >
          { item.name }
        </button> ) }
      </div>
    </div>
  </div>

}

export default ByDate
